/** The diagram embed iframe (`/embed/*`) renders inside the pattern composer's
 *  paper page, so personal view preferences — the interface theme and the
 *  canvas background color — never apply there: it always renders light, on
 *  Paper, exactly as it did before either preference existed. The one shared
 *  check for that; the `theme-boot` inline script in src/index.html repeats it
 *  (it runs before any bundle loads). */
const EMBED_PATH_PREFIX = '/embed/';

/** True when `pathname` (default: the current document's) is an embed route. */
export function isEmbedDocument(pathname: string = currentPathname()): boolean {
    return pathname.startsWith(EMBED_PATH_PREFIX);
}

function currentPathname(): string {
    try {
        return typeof window === 'undefined' ? '' : window.location.pathname;
    } catch {
        return '';
    }
}
